import '../consent';
import { initDataDogRum } from '../datadog/start-datadog';

// run
export const initSLFPage = async () => {
	initDataDogRum();
};
